"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    tableWrapper: _objectSpread({}, theme.scrollbars.main),
    compactRowClickable: {
      "&:hover": {
        cursor: "pointer"
      }
    },
    largeRoot: {
      borderSpacing: theme.spacing(0, 0.5),
      borderCollapse: "separate"
    },
    largeCell: {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      border: "none"
    },
    largeHeaderRow: {
      backgroundColor: "transparent"
    },
    largeHeaderCell: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      fontWeight: 800,
      border: "none",
      textTransform: "uppercase",
      backgroundColor: "transparent !important"
    },
    largeRow: {
      backgroundColor: theme.palette.background.paper
    },
    largeRowClickable: {
      backgroundColor: theme.palette.background.paper,
      "&:hover": {
        cursor: "pointer"
      }
    },
    largeFooter: {
      backgroundColor: "transparent"
    },
    emptyStateContent: {
      textAlign: "center"
    },
    tableWrapperSetHeight: {
      maxHeight: "40rem",
      overflow: "auto"
    }
  };
};

exports.styles = styles;